import { useEffect, useState } from 'react';

/**
 * Seconds left of a wait the server imposed (429 with `Retry-After`), counting down once a second. Both login screens
 * use it to keep the button disabled and show "(N s)". Returns the seconds left and the function that starts a wait.
 */
export function useCountdown(): readonly [number, (seconds: number) => void] {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    if (seconds <= 0) return undefined;
    const timer = setTimeout(() => {
      setSeconds((s) => s - 1);
    }, 1_000);
    return () => {
      clearTimeout(timer);
    };
  }, [seconds]);
  return [seconds, setSeconds] as const;
}
